import * as _ from 'lodash';
//  Note that we are intentionally using this Project type (and not the model-typings one), since it includes the associations that we need.
import type { Project } from '../../../../types';

const projectIssueTrackerSettingsFields = [
  'useGlobalTrackerSettings',
  'issue_tracker_type',
  'issue_tracker_url',
  'issueTrackerProjectIds',
  'issueTrackerIssueTypes',
  'issueTrackerLabels',
  'issueTrackerCustomFields',
] as const;
export type ProjectIssueTrackerSettings = Pick<Project, typeof projectIssueTrackerSettingsFields[number]>;

export const pickIssueTrackerSettingsFromProject = (project: Project): ProjectIssueTrackerSettings =>
  _.pick(project, projectIssueTrackerSettingsFields);
